<header>
    <div class=" ">
        <nav class=" navbar navbar-expand-lg fixed-top backdrop ">
            <div class="container">

                <a [href]="'/' + global.languageCode"><img class="navbar-brand" src="images/logos/logo.png"
                        alt=""></a>
                <button class="navbar-toggler" type="button" data-toggle="collapse"
                    data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="container navbar-nav m-auto">
                        <li class="nav-item">
                            <a class="nav-link hvr-grow" (click)="navigateToSection('aboutBespoken', '1')"> {{ 'aboutBespoken' | translate }} </a>
                        </li>
                        <li class="nav-item ">
                            <a class="nav-link hvr-grow" (click)="navigateToSection('ourFeatures', '1')"> {{ 'ourFeatures' | translate }} </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link hvr-grow" (click)="navigateToSection('faq', '1')"> {{ 'FAQs' | translate }} </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link hvr-grow" (click)="navigateToSection('contactUs', '1')"> {{ 'contactUs' | translate }} </a>
                        </li>
                    </ul>
                </div>
                <div class="actions"> 
                    <a class="lang-link" [href]="generateUrlWithQueryParams()">
                        <span *ngIf="global?.languageCode == 'en'" class="lang-text hvr-grow">عربي</span>
                        <span *ngIf="global?.languageCode == 'ar'" class="lang-text hvr-grow">English</span>
                    </a> 

                    <p class="get-the-app-btn hvr-grow" (click)="navigateToSection('hero', '1')"> {{ 'getTheApp' | translate}} </p>
                </div>
            </div>
        </nav>
    </div>
</header>